import type { FC, PropsWithChildren } from 'react'
import { CwsTag } from '@components/cws'
import clsx from 'clsx'

export interface BadgeProps {
  size?: 'sm'
  type?: 'regular'
  className?: string
  isLast?: boolean
}

const Badge: FC<PropsWithChildren<BadgeProps>> = (props) => {
  const { type, className, children, isLast } = props
  return (
    <CwsTag
      className={!isLast ? clsx('cws-mr-tiny', className) : className}
      theme={type !== 'regular' ? 'pink' : 'midnight'}
    >
      {children}
    </CwsTag>
  )
}

export default Badge
